import React from 'react';
import axios from 'axios';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const ChangeProfileData = ({ closeModal, openProfileModal }) => {
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [userId, setUserId] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [firstName, setFirstName] = React.useState('');
    const [surname, setSurname] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [branch, setBranch] = React.useState('');
    const [role, setRole] = React.useState('');
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/user', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setUserId(response.data.id);
                setLastName(response.data.lastname);
                setFirstName(response.data.firstname);
                setSurname(response.data.surname);
                setEmail(response.data.email);
                setBranch(response.data.branch);
                setRole(response.data.role);

                setLoading(false);
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
                setWarning('Ошибка получения данных');
                setLoading(false);
            });
        } else {
            handleLogout();
        }
    }, []);

    const changeData = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`/api/change-profile-data`, {
                userId,
                lastName,
                firstName,
                surname,
                branch,
              });
            if (response.status == 200) {
                setStatus('Данные профиля успешно изменены');
            } else {
                setStatus('Ошибка изменения данных профиля');
            }
        } catch (err) {
            setStatus('Ошибка обновления данных учётной записи: ' + (err.response ? err.response.data : err.message));
        }
    }


    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changeData(e)}>
            <div className={styles.header}>
                <div className={styles.headlineWithBackBtn}>
                    <div className={styles.backBtnContainer}>
                    <svg onClick={() => {openProfileModal()}} viewBox="0 0 24 24">
                        <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                    </svg>
                    </div>
                    <h1>Изменить данные учётной записи</h1>
                </div>
                <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                </svg>
            </div>
            <div className={styles.main}>
                {loading ? (
                    <Loading />
                ) : warning ? (
                    <a>{warning}</a>
                ) : (
                    <span style={{width: '320px', margin: '0 auto'}}>
                        <h2 style={{display: 'flex', justifyContent: 'center'}}>Адрес электронной почты</h2>
                        <input type="text" placeholder='Введите email' value={email} disabled />
                        <a className={styles.statusPanel}>
                            Изменение адреса электронной почты недоступно. Если Вы хотите совершить это действие, обратитесь в поддержку или к администратору сети.
                        </a>
                        <h2 style={{margin: '0 0 0 0', display: 'flex', justifyContent: 'center'}}>Фамилия</h2>
                        <input type="text" placeholder='Введите фамилию' value={lastName} onChange={(e) => setLastName(e.target.value)} />
                        <h2 style={{display: 'flex', justifyContent: 'center'}}>Имя</h2>
                        <input type="text" placeholder='Введите имя' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                        <h2 style={{display: 'flex', justifyContent: 'center'}}>Отчество</h2>
                        <input type="text" placeholder='Введите отчество' value={surname} onChange={(e) => setSurname(e.target.value)} />
                        <h2 style={{display: 'flex', justifyContent: 'center'}}>Основной регион деятельности</h2>
                        <input type="text" placeholder='Введите основной регион деятельности' value={branch} onChange={(e) => setBranch(e.target.value)} />
                        {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                        <button className='button maxWidth' type='submit'>Подтвердить изменение данных</button>
                    </span>
                )}
            </div>
            </form>
        </div>
    )
}

export default ChangeProfileData;